"use strict";
import request from "@/utils/request";
const config = require("@/../config/config.json");
import logger from "@/utils/logger";

export async function svc_report(data) {
  let endpoint = data.endPoint;
  delete data.endPoint;

	return request(`${config.apiUrl}reports/${endpoint}`, {
    method: "POST",
    data: data,
    responseType: "blob"
	});
}
